// ----------------------------------------------------------------------
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, import/no-default-export
export default function Button(theme) {
    return {
        "MuiButton": {
            "styleOverrides": {
                "containedInherit": {
                    "&:hover": {
                        "backgroundColor": theme.palette.grey[400],
                        "color": theme.palette.primary.dark,
                    },
                    "backgroundColor": theme.palette.secondary.dark,
                    "color": theme.palette.primary.dark,
                },
                "containedPrimary": {
                    "&:hover": {
                        "backgroundColor": theme.palette.primary.dark,
                        "color": theme.palette.secondary.dark,
                    },
                    "backgroundColor": theme.palette.primary.main,
                    "color": `${theme.palette.secondary.dark} !important`,
                },
                "fullWidth ": {
                    "width": "100%"
                },
                "outlinedInherit": {
                    "&:hover": {
                        "backgroundColor": theme.palette.action.hover,
                        "color": theme.palette.secondary.dark
                    },
                    "border": `1px solid ${theme.palette.secondary.dark}`,
                },
                "root": {
                    "&:hover": {
                        "boxShadow": "none",
                    },
                    "borderRadius": "500px",
                },
                "sizeLarge": {
                    "fontSize": "20px",
                    "height": 55,
                    "letterSpacing": "0.08rem",
                },
                "sizeMedium": {
                    "height": 40
                },
                "textInherit": {
                    "&:hover": {
                        "backgroundColor": theme.palette.action.hover,
                    },
                },
            },
        },
    };
}
